export default __webpack_public_path__ + "static/media/View-documentation.4a5ab422.md";